export default {
    parent: 'ApplicationLayout',
    template: `
        <ui-view class="body-wrapper"></ui-view>
    `
};



// WEBPACK FOOTER //
// ./src/app/layouts/scorm/index.js